export default "__VITE_ASSET__D72N8uev__"